import { matchPath } from "react-router-dom";

export const isUserManagementPath = (pathname) =>
  Boolean(matchPath({ path: "/users", end: true }, pathname));
